import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrSY: CultureInfo = {
  name: 'fr-SY',
  displayName: 'français (Syrie)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-SY',
  parent: CultureInfoFr
};
